import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";

// import { FormWrapper, OutletWrapper } from '../../../../assets/Outlet.styles';

import { STATUS, CREDITBLOCK } from '../../../utils/constants';

import { fetchIsos, fetchProcessors, fetchPrefix, fetchProcessorTerminalModels, fetchProcessorConnections, fetchBankStatementDescriptors } from "../../../redux/actions/DropdownActions";
import { addProcessorTerminal, editProcessorTerminal, checkTerminalID, setModified, setProcessorTerminalID, fetchProcessorTerminal, setClone } from '../../../redux/actions/ProcessorTerminalActions';
import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';


const AddEditProcessorTerminal = (props) => {

    const navigate = useNavigate()

    const [processorTermID, setProcessorTermID] = useState('')
    const [processorID, setProcessorID] = useState('')
    const [connectionID, setConnectionID] = useState('')
    const [processorTermStatusID, setProcessorTermStatusID] = useState(1);
    const [, setStatusMonitoring] = useState("false");
    const [terminalProcessorModel, setTerminalProcessorModel] = useState('')
    const [bankStmtDescription, setBankStmtDescription] = useState('')
    const [autoBatch, setAutoBatch] = useState("false");
    const [autoBatchTime, setAutoBatchTime] = useState('')
    const [settlementDelay, setSettlementDelay] = useState('')
    const [, setTimezone] = useState('')
    const [isoValue, setIsoValue] = useState('');
    const [merchantID, setMerchantID] = useState('')

    const [processorTermIDError, setProcessorTermIDError] = useState(false)
    const [processorIDError, setprocessorIDError] = useState(false)
    const [processorTermStatusIDError, setProcessorTermStatusIDError] = useState(false);
    const [terminalProcessorModelError, setTerminalProcessorModelError] = useState(false)
    const [bankStmtDescriptionError, setBankStmtDescriptionError] = useState(false)
    const [connectionIDError, setConnectionIDError] = useState(false)
    const [autoBatchError, setAutoBatchError] = useState(false)
    const [isoError, setIsoError] = useState(false);
    const [merchantError, setMerchantError] = useState(false)

    const [merchantDropdown, setMerchantDropdown] = useState([])


    useEffect(() => {
        props.fetchIsos()
        props.fetchProcessors()
        props.fetchPrefix()
        props.fetchProcessorTerminalModels()
        props.fetchProcessorConnections()
        props.fetchBankStatementDescriptors()

        console.log('Clone  : ' + props.PROCESSORTERMINALREDUCER.clone)

        if (props.edit || props.PROCESSORTERMINALREDUCER.clone) {
            let data = props.PROCESSORTERMINALREDUCER.processorTerminalData[0]
            console.log('Data : {} ' + data)

            if (props.edit) {
                setProcessorTermID(data.processorTermID)
            }
            setProcessorID(data.processorID)
            setConnectionID(data.connectionID)
            setIsoValue(data.isoID)

            let merchants = props.DROPDOWNREDUCER.isosData?.filter(iso => {
                return iso.isoID === data.isoID
            })
            setMerchantDropdown(merchants[0]?.merchants)
            setMerchantID(data.merchantID)

            setBankStmtDescription(data.bankStmtDescriptor)

            setProcessorTermStatusID(data.processorTermStatusID)

            setStatusMonitoring(data.statusMonitoringEnabled)
            setTerminalProcessorModel(data.processorTerminalModelID)
            setTimezone(data.timeZone)
            setAutoBatch(String(data.autoBatch))
            setAutoBatchTime(data.autoBatchTime)
            setSettlementDelay(data.settlementDelay !== null && data.settlementDelay !== undefined ? data.settlementDelay : '')
            props.setClone(false)

        } else {
            handleReset()
        }
    }, [])


    useEffect(() => {
        if (props.PROCESSORTERMINALREDUCER.modified) {
            props.setModified(false)
            props.setClone(false)
            navigate('/processorTerminal/view')
        }
    }, [props.PROCESSORTERMINALREDUCER])

    const checkTerminalID = (event) => {
        props.checkTerminalID(event.target.value)
    }

    // Settlement delay accepts digits only (and allows clearing the field)
    const handleSettlementDelayChange = (event) => {
        const digitsOnly = event.target.value.replace(/[^0-9]/g, '')
        setSettlementDelay(digitsOnly)
    }


    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value
        if (targetValue) {

            switch (targetName) {
                case 'processorTermID':
                    if (targetValue.length <= 8) {
                        setProcessorTermIDError(false)
                        setProcessorTermID(targetValue.toUpperCase())
                    }
                    console.log('Prefixes : ' , props.DROPDOWNREDUCER.terminalPrefix)
                    let processId = props.DROPDOWNREDUCER.terminalPrefix?.filter(tp => {
                        return targetValue.includes(tp.terminalIDPrefix)
                    })
                    console.log('processId : ' ,processId)
                    if (processId && processId.length)
                        setProcessorID(processId[0].processorID)
                    break;
                case 'processorID':
                    setprocessorIDError(false)
                    setProcessorID(targetValue)
                    break;
                case 'isoID':
                    setIsoError(false)
                    setIsoValue(targetValue);
                    let merchants = props.DROPDOWNREDUCER.isosData.filter(iso => {
                        return String(iso.isoID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                    })
                    setMerchantDropdown(merchants[0]?.merchants)
                    break;
                case 'merchantID':
                    setMerchantError(false);
                    setMerchantID(targetValue)
                    break;
                case 'connectionID':
                    setConnectionIDError(false)
                    setConnectionID(targetValue)
                    break;
                case 'processorTermStatusID':
                    setProcessorTermStatusIDError(false)
                    setProcessorTermStatusID(targetValue)
                    break
                case 'terminalProcessorModel':
                    setTerminalProcessorModel(targetValue)
                    setTerminalProcessorModelError(false)
                    break;
                case 'bankStmtDescription':
                    setBankStmtDescription(targetValue)
                    setBankStmtDescriptionError(false)
                    break;
                case 'autoBatch':
                    setAutoBatchError(false)
                    setAutoBatch(targetValue)
                    break;
                case 'autoBatchTime':
                    setAutoBatchTime(targetValue)
                    break; default:
                    break;
            }
        }
    }


    const handleSubmit = (event) => {

        event.preventDefault();

        let body = {}

        if (processorTermID) {
            body.processorTermID = processorTermID
        } else {
            setProcessorTermID(true)
        }

        if (processorID) {
            body.processorID = processorID
        } else {
            setprocessorIDError(true)
        }

        if (processorTermStatusID) {
            setProcessorTermStatusIDError(false);
            body.processorTermStatusID = processorTermStatusID
        } else {
            setProcessorTermStatusIDError(true)
        }

        if (bankStmtDescription) {
            body.bankStmtDescriptor = bankStmtDescription
        } else {
            setBankStmtDescriptionError(true)
        }
        if (autoBatch) {
            body.autoBatch = autoBatch
            setAutoBatchError(false)
        } else {
            setAutoBatchError(true)
        }

        if (autoBatchTime) {
            body.autoBatchTime = autoBatchTime
        }

        if (settlementDelay !== '' && settlementDelay !== null && settlementDelay !== undefined) {
            body.settlementDelay = Number(settlementDelay)
        }

        if (connectionID) {
            body.connectionID = connectionID
            setConnectionIDError(false)
        } else {
            setConnectionIDError(true)
        }



        if (terminalProcessorModel) {
            body.processorTerminalModelID = terminalProcessorModel
        } else {
            setTerminalProcessorModelError(true)
        }

        if (merchantID) {
            body.merchantID = merchantID
        } else {
            setMerchantError(false)
        }
        if (processorTermID && processorTermStatusID && processorID && connectionID && !props.edit && !bankStmtDescriptionError && terminalProcessorModel && autoBatch && merchantID) {
            console.log(body)
            props.addProcessorTerminal(body)
            props.setProcessorTerminalID(body.processorTermID)
        } else if (processorTermStatusID && processorID && connectionID && props.edit && !bankStmtDescriptionError && terminalProcessorModel && merchantID) {
            console.log(body)
            props.setProcessorTerminalID(body.processorTermID)
            props.editProcessorTerminal(body)
        }

    }

    const handleResetPreventingRefresh = (event) => {
        event.preventDefault();
        handleReset()

    }

    const handleReset = (event) => {

        setProcessorTermID('')
        setProcessorID('')
        setStatusMonitoring('false')
        setProcessorTermStatusID(1)
        setProcessorTermStatusIDError(false)
        setprocessorIDError(false)
        setTerminalProcessorModelError(false)
        setBankStmtDescription('')
        setBankStmtDescriptionError('')
        setSettlementDelay('')
    }
    const handleEditCancel = () => {
        navigate('/processorTerminal/view');
    }


    return (


        <Panel >
            <PanelHeader>Terminal Form</PanelHeader>
            <PanelBody>
                <form className="fs-13px">

                    <div className="mb-3">
                        <div className="row gx-3">
                            <div className="col-md-3 mb-2 mb-md-0">
                                <label className={"col-md-6 " + (processorTermIDError ? 'text-danger' : '')}><b>Processor Terminal ID</b></label>
                                <input type="text" className="form-control fs-13px"
                                    name="processorTermID"
                                    onChange={handleChange}
                                    onBlur={checkTerminalID}
                                    value={processorTermID ? processorTermID : ''}
                                    disabled={props.edit}
                                />
                            </div>

                            <div className="col-md-3 mb-2 mb-md-0">


                                <label className={"col-md-3 " + (processorTermStatusIDError ? 'text-danger' : '')}><b>Status</b></label>

                                <select className="form-select"
                                    value={processorTermStatusID ? processorTermStatusID : 1}
                                    error={setProcessorTermStatusIDError}
                                    onChange={handleChange}
                                    name='processorTermStatusID'
                                >

                                    {STATUS.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.status}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                    </div>

                    <div className="mb-3">

                        <div className="row gx-6">

                            <div className="col-md-2 mb-2 mb-md-0">

                                <label className={"col-md-12 " + (processorIDError ? 'text-danger' : '')} ><b>Processor</b></label>
                                <select className="form-select"
                                    onChange={handleChange}
                                    name='processorID'
                                    value = {processorID ? processorID: ''}
                                >
                                    <option value=''>Select Processor</option>
                                    {props.DROPDOWNREDUCER.processorsData?.map((option) => (
                                        <option key={option.processorID} value={option.processorID}>
                                            {option.processorName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2 mb-2 mb-md-0">


                                <label className={"col-md-12 " + (bankStmtDescriptionError ? 'text-danger' : '')}><b>Statement Descriptor</b></label>

                                <select className="form-select"

                                    label="Statment Descriptor"
                                    value={bankStmtDescription ? bankStmtDescription : ''}
                                    error={bankStmtDescriptionError}
                                    onChange={handleChange}
                                    name='bankStmtDescription'
                                >
                                    <option value=' '>Select Statement Descriptor </option>

                                    {props.DROPDOWNREDUCER.bankStatementDescriptors?.map((option) => (
                                        <option key={option.bankStatementDescriptorID} value={option.bankStatementDescriptor}>
                                            {option.bankStatementDescriptor}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-2 mb-2 mb-md-0">


                                <label className={"col-md-12 " + (connectionIDError ? 'text-danger' : '')}><b>Connection</b></label>

                                <select className="form-select"
                                    value={connectionID ? connectionID : ''}
                                    error={bankStmtDescriptionError}
                                    onChange={handleChange}
                                    name='connectionID'
                                >
                                    <option value=' '>Select Connection </option>

                                    {props.DROPDOWNREDUCER.processorConnections?.map((option) => (
                                        <option key={option.connectionID} value={option.connectionID}>
                                            {option.connectionName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                    </div>


                    <div className="mb-3">

                        <div className="row gx-3">

                            <div className="col-md-3 mb-2 mb-md-0">

                                <label className={"col-md-3 " + (isoError ? 'text-danger' : '')}><b>ISO</b></label>
                                <select className="form-select"
                                    value={isoValue ? isoValue : ''}
                                    error={isoError}
                                    onChange={handleChange}
                                    name='isoID'
                                >
                                    <option value=''>Select ISO</option>

                                    {props.DROPDOWNREDUCER.isosData.map((option) => (
                                        <option key={option.isoID} value={option.isoID}>
                                            {option.isoName}
                                        </option>
                                    ))}

                                </select>
                            </div>

                            <div className="col-md-3 mb-2 mb-md-0">
                                <label className={"col-md-3 " + (merchantError ? 'text-danger' : '')}><b>Merchant</b></label>

                                <select className="form-select"
                                    value={merchantID ? merchantID : ''}
                                    error={merchantError}
                                    onChange={handleChange}
                                    name='merchantID'
                                >

                                    <option value=''>Select Merchant</option>
                                    {merchantDropdown.map((option) => (
                                        <option key={option.merchantID} value={option.merchantID}>
                                            {option.merchantName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>

                    </div>


                    <div className="mb-3">

                        <div className="row gx-3">

                            <div className="col-md-3 mb-2 mb-md-0">
                                <label className="col-md-12"><b>Auto Batch</b></label>

                                <select className="form-select"
                                    value={autoBatch ? autoBatch : 'false'}
                                    error={autoBatchError}
                                    onChange={handleChange}
                                    name='autoBatch'
                                >
                                    {CREDITBLOCK.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.status}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            {autoBatch === 'true' ? <div className="col-md-3 mb-2 mb-md-0">
                                <label className="col-md-12"><b>Auto Batch Time</b></label>

                                <input
                                    name="autoBatchTime"
                                    value={autoBatchTime ? autoBatchTime : ''}
                                    type="time"
                                    onChange={handleChange}
                                    className="form-control fs-13px"
                                ></input>
                            </div> : null}

                            <div className="col-md-3 mb-2 mb-md-0">
                                <label className="col-md-12"><b>Settlement Delay</b></label>

                                <input
                                    name="settlementDelay"
                                    value={settlementDelay}
                                    type="text"
                                    inputMode="numeric"
                                    onChange={handleSettlementDelayChange}
                                    className="form-control fs-13px"
                                />
                            </div>


                        </div>
                    </div>



                    <div className="mb-3">
                        <div className="row gx-3">
                            <div className="col-md-6 mb-2 mb-md-0">

                                <label className={"col-md-12 " + (terminalProcessorModelError ? 'text-danger' : '')} ><b>EPROM</b></label>
                                <select className="form-select"
                                    onChange={handleChange}
                                    name='terminalProcessorModel'
                                    value={terminalProcessorModel ? terminalProcessorModel : ' '}
                                >
                                    <option value=''>Select Terminal Model</option>

                                    {props.DROPDOWNREDUCER.processorTerminalModels.map((option) => (
                                        <option key={option.modelID} value={option.modelID}>
                                            {option.modelAndVersions}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>

                    </div>


                    <div className="mb-3">

                        <div className="row gx-3">

                            <div className="col-md-3 mb-2 mb-md-0">
                                <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleSubmit}>{props.edit ? 'Save' : 'Add'}</button>
                            </div>

                            <div className="col-md-3 mb-2 mb-md-0">

                                {props.edit ? <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={handleEditCancel}>Cancel</button>
                                    : <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={handleResetPreventingRefresh}>Reset</button>}


                            </div>
                        </div>
                    </div>

                </form>
            </PanelBody>
        </Panel>



    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchIsos,
    fetchProcessorTerminal,
    fetchProcessors,
    fetchPrefix,
    fetchProcessorTerminalModels,
    fetchProcessorConnections,
    fetchBankStatementDescriptors,
    addProcessorTerminal,
    editProcessorTerminal,
    checkTerminalID,
    setModified,
    setProcessorTerminalID,
    setClone
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditProcessorTerminal);
